export default __webpack_public_path__ + "static/media/WiFi_ActivationCode_ti40040.4fd4a75c.png";